<template>
    <div class="select-component">
        <multiselect
            :placeholder="t('Select')"
            :options="availableValues"
            :multiple="isMultiple"
            :close-on-select="true"
            :clear-on-select="false"
            track-by="id"
            label="name"
            :loading="loading"
            v-model="value"
            @select="onSelect"
            @open="onOpen"
        >
            <div slot="noOptions">{{ t('List is empty') }}</div>
        </multiselect>
    </div>
</template>

<script>

import Multiselect from '../Multiselect';
import ValueChecker from "../../services/ValueChecker";

export default {
    components: {Multiselect},
    props: {
        config: {
            type: Object,
            default: () => {
                return {};
            }
        },
        column: {
            type: Object,
        },
        row: {
            type: Object,
        },
        name: {
            Type: String,
        },
        parentIndex: {
            Type: String,
        },
        eventBus: {
            Type: Object,
        },
        rowIndex: {
            Type: Number,
        }
    },
    computed: {
        getValue() {
            return this.row[this.column.data];
        },
        isMultiple() {
            return ValueChecker.isUndefinedOrNull(this.config.multiple) ? false : this.config.multiple;
        }
    },
    data() {
        return {
            errors: [],
            value: null,
            availableValues: [],
            loading: false,
        };
    },
    mounted() {
        this.loading = true;
        let dataLoader = this.eventBus.getDataLoader(this.config);
        dataLoader.bindEvents(this.setAvailableValues);
        dataLoader.load();
        this.eventBus.$on(this.config['index'] + ':loadValuesAndSetFirstValue', this.loadValuesAndSetFirstValue);
    },
    beforeDestroy() {
        this.eventBus.$off(this.config['index'] + ':loadValuesAndSetFirstValue', this.loadValuesAndSetFirstValue);
    },
    methods: {
        onOpen() {
            let dataLoader = this.eventBus.getDataLoader(this.config);
            dataLoader.load();
        },
        onSelect(val) {
            this.row[this.column.data] = val.name || val;
        },
        setAvailableValues(data) {
            this.availableValues = data;
            let value = this.row[this.column.data];
            this.value = this.availableValues.filter(item => value === item.name);
            this.loading = false;
        },
        async loadValuesAndSetFirstValue(data) {
            if (this.rowIndex !== data.eventData[0].rowIndex) {
                return
            }

            let dataLoader = this.eventBus.getDataLoader(this.config);
            dataLoader.isLoaded = false;
            const loadedData = await dataLoader.load();

            if (!Array.isArray(loadedData) || 0 === loadedData.length) {
                return;
            }

            const firstValue = loadedData[0];
            this.value = [firstValue];
            this.row[this.column.data] = firstValue.name;
            this.loading = false;
        }
    }
}

</script>

<style scoped>
.select-component {
    width: 80% !important;
}
</style>


// WEBPACK FOOTER //
// SelectColumnComponent.vue?7ca828d8